<!--
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-20 09:36:26
 * @Description: TODO
-->
<template>
  <div class="index-div row">
    <div style="flex: 2;align-self: center;">
      <el-carousel height="180px" indicator-position="outside" @change="onChange">
        <el-carousel-item v-for="item in data" :key="item.name" >
          <div class="col al-center jc-center">
            <div class="name">{{item.name}}</div>
            <div class="row al-center mt30">
              <div class="price">{{item.dataLast.detailLatestpri? parseFloat(item.dataLast.detailLatestpri).toFixed(2):'---' }}</div>
              <div class="col ml30">
                <div :class="[item.dataLast.detailChange<0 ? 'down' : 'up']">{{ item.dataLast.detailChange }}</div>
                <div :class="[item.dataLast.detailChange < 0 ? 'down' : 'up']">{{item.dataLast.detailLimit }}</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      id="chart"
      class="col"
      style="flex: 3; background-color: #08183c"
    ></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
// 基于准备好的dom，初始化echarts实例
var myChart = null

let option = {
  xAxis: {
    type: 'category',
    data: ['A', 'B', 'C']
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: [120, 200, 150],
      type: 'line',
      smooth: true,
      lineStyle: {
        normal: {
          color: 'rgba(55, 162, 218, 0.6)'
        }
      }
    }
  ]
}

export default {
  name: 'TzIndex',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {}
  },
  mounted () {
    myChart = echarts.init(document.getElementById('chart'))
    myChart.setOption(option)
  },
  methods: {
    onChange (e) {
      let datanew = this.data[e].dataTotal.slice()
      let dateArr = datanew.reverse().map(item => item.createTime.split(' ')[0])
      let dataArr = datanew.map(item => parseFloat(item.detailLatestpri))
      // 检查生成的数组长度是否有效
      if (dateArr.length !== dataArr.length) {
        return
      }
      let option2 = {
        gird: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        xAxis: {
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        },
        yAxis: {
          type: 'value',
          boundaryGap: false
        },
        series: [
          {
            data: [1200, 2230, 1900, 2100, 3500, 4200, 3985],
            type: 'line',
            lineStyle: {
              normal: {
                color: 'rgba(55, 162, 218, 0.6)'
              }
            }
          }
        ]
      }
      // 添加日志来调试
      option2.xAxis.data = dateArr
      option2.series[0].data = dataArr
      myChart.setOption(option2)
    }
  }
}
</script>

<style lang="less" >
.index-div {
  height: 100%;
  .name {
    color: #26defd;
    font-size: 24px;
    font-weight: bold;
    line-height: 60px;
    border-bottom: 2px solid #26defd;
    padding: 0 30px;
  }
  .price {
    color: #26defd;
    font-size: 34px;
    font-weight: bold;
  }
  .up {
    color: #f8a036;
    font-size: 24px;
    font-weight: bold;
  }
  .down {
    color: #25e49c;
    font-size: 24px;
    font-weight: bold;
  }
}
</style>
